module.exports = __webpack_public_path__ + "static/logo_button-c3ac7c93a0621b582c2e189f770c9493.png";